import { use } from 'react'

import { FormLayoutContext } from '../context'

export const useFormLayout = () => {
  return use(FormLayoutContext)
}
